// FileDownloadLoader.jsx
import React, {useState, useEffect} from "react";
import { Stack, Typography, LinearProgress, Card, CardContent, Modal, Dialog } from "@mui/material";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import { keyframes } from "@mui/system";

const shake = keyframes`
  0%   { transform: rotate(0deg); }
  15%  { transform: rotate(-8deg); }
  30%  { transform: rotate(8deg); }
  45%  { transform: rotate(-6deg); }
  60%  { transform: rotate(6deg); }
  75%  { transform: rotate(-3deg); }
  100% { transform: rotate(0deg); }
`;

const messages = [
  "Initialize download",
  "Server messages a worker node",
  "Worker node starts processing data",
  "Worker node pushes results to cloud",
  "Checking if cloud has the data",
  "Almost done..."
];

export default function FileDownloadLoader() {

  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prev) => (prev + 1) % messages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Dialog open={true}>
    <Card elevation={1} sx={{ maxWidth: 320, borderRadius: 1, p: 1 }}>
      <CardContent>
        <Stack spacing={2} alignItems="center" textAlign="center">
          <InsertDriveFileRoundedIcon
            fontSize="large"
            sx={{
              color: "secondary.main",
              animation: `${shake} 0.8s ease-in-out infinite`,
            }}
          />
          <Typography variant="h6" fontWeight={700}>
            Download starting…
          </Typography>
          <LinearProgress color="secondary" sx={{ width: "100%" }} />
          <Typography variant="caption" color="text.secondary">
            Please wait while your file download begins
          </Typography>

          <Typography variant="caption" color="textPrimary">
            <u>Stacktrace</u>: {messages[currentMessageIndex]}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
    </Dialog>
  );
}